import { notification } from 'antd';

const showAlert = (type, title, message, duration = 3) => {
  const config = {
    message: title,
    description: message,
    duration,
    placement: 'topRight',
  };

  switch (type) {
    case 'success':
      notification.success(config);
      break;
    case 'error':
      notification.error(config);
      break;
    case 'warning':
      notification.warning(config);
      break;
    case 'info':
      notification.info(config);
      break;
    default:
      notification.info(config);
  }
};

export const alertSuccess = (title, message, duration = 3) => {
  showAlert('success', title, message, duration);
};

export const alertError = (title, message, duration = 3) => {
  showAlert('error', title, message, duration);
};

export const alertWarning = (title, message, duration = 3) => {
  showAlert('warning', title, message, duration);
};

export const alertInfo = (title, message, duration = 3) => {
  showAlert('info', title, message, duration);
};

// Specific alerts for Visit actions
export const visitAcceptedSuccess = (visitorName, date, time) => {
  alertSuccess(
    'Accepted',
    `${visitorName}'s visit has been accepted for ${date}, from ${time}.`
  );
};

export const visitDeclinedSuccess = (visitorName) => {
  alertSuccess(
    'Declined',
    `You have declined the visit from ${visitorName}.`
  );
};

export const visitUpdateError = (error) => {
  alertError(
    'Error',
    error || 'Failed to update visit status. Please try again.'
  );
};

// Specific alerts for Reservation actions
export const reservationCreatedSuccess = (guestName, date, time) => {
  alertSuccess(
    'Reservation Created',
    `Reservation created for ${guestName} on ${date}, from ${time}.`
  );
};

export const reservationUpdatedSuccess = (guestName) => {
  alertSuccess(
    'Reservation Updated',
    `Reservation for ${guestName} has been updated successfully.`
  );
};

export const reservationCancelledSuccess = (guestName) => {
  alertSuccess(
    'Reservation Cancelled',
    `Reservation for ${guestName} has been cancelled.`
  );
};

export const reservationError = (error) => {
  alertError(
    'Error',
    error || 'Failed to process reservation. Please try again.'
  );
};

export default {
  showAlert,
  alertSuccess,
  alertError,
  alertWarning,
  alertInfo,
  visitAcceptedSuccess,
  visitDeclinedSuccess,
  visitUpdateError,
  reservationCreatedSuccess,
  reservationUpdatedSuccess,
  reservationCancelledSuccess,
  reservationError,
};
